// extracted by mini-css-extract-plugin
export var speakerContainer = "speakerWidget-module--speakerContainer--28f65";
export var speakerContent = "speakerWidget-module--speakerContent--9ecac";
export var speakerLabel = "speakerWidget-module--speakerLabel--bc995";
export var speakerName = "speakerWidget-module--speakerName--cf657";